import { useEffect, useState } from "react";
import MobileFilter from "../../../components/ui/MobileFilter";
import SearchableDropdown from "../../../components/ui/tableDataDropdowns/SearchableDropdown";
import DebouncedInput from "../../../components/helper/DebouncedInput";
import { searchIcon } from "../../../assetData/icons";

const MasterMFHeader = ({
  tableData,
  setDateFilters,
  setIsFilter,
  isFilter,
  isLoading,
  setGlobalFilters,
  globalFilter,
}) => {
  const [value, setValue] = useState();
  const [selectedValues, setSelectedValues] = useState({});
  const [alertMessage, setAlertMessage] = useState({ type: "", message: "" });

  useEffect(() => {
    setDateFilters(value);
  }, [value]);

  const handleApplyFilters = (selectedValues) => {
    setDateFilters({
      created_start_date: selectedValues?.date_from,
      created_end_date: selectedValues?.date_to,
      updated_start_date: selectedValues?.date_from_2,
      updated_end_date: selectedValues?.date_to_2,
    });
  };

  const handleImportSuccess = (message) => {
    setAlertMessage({ type: "success", message });
    // Auto-hide alert after 3 seconds
    setTimeout(() => {
      setAlertMessage({ type: "", message: "" });
    }, 3000);
  };

  const scripMasterFilters = [
    {
      name: "date_from",
      label: "Created From",
      type: "date from",
    },
    {
      name: "date_to",
      label: "Created  To",
      type: "date to",
    },
    {
      name: "date_from_2",
      label: "Updated From",
      type: "date from 2",
    },
    {
      name: "date_to_2",
      label: "Updated To",
      type: "date to 2",
    },
  ];

  return (
    <>
      {/* Alert Message */}
      {alertMessage.message && (
        <div
          className={`fixed right-4 top-4 z-50 rounded-lg px-4 py-3 shadow-lg ${
            alertMessage.type === "success"
              ? "border border-green-300 bg-green-100 text-green-800"
              : "border border-red-300 bg-red-100 text-red-800"
          }`}
        >
          <div className="flex items-center gap-2">
            {alertMessage.type === "success" ? (
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            <span>{alertMessage.message}</span>
          </div>
        </div>
      )}

      <div className="flex w-full flex-row">
        <div className="mb-3 flex w-full flex-wrap items-baseline justify-between  max-sm:hidden">
          <div className="flex w-full items-baseline justify-between gap-4">
            <div className="flex w-full flex-wrap items-baseline gap-4">
              <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
                <div className="flex w-full flex-col gap-2 ">
                  <label>AMC Name</label>
                  <SearchableDropdown
                    data={tableData}
                    valueKey={"amc_name"}
                    displayKey={"amc_name"}
                    filterKey={"amc_name"}
                    setFilter={(val) =>
                      setValue((prev) => ({ ...prev, amc_name: val }))
                    }
                    type={"searchable"}
                    loading={isLoading}
                  />
                </div>
              </div>
              <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
                <div className="flex w-full flex-col gap-2 ">
                  <label>MF Scheme Name</label>
                  <SearchableDropdown
                    data={tableData}
                    valueKey={"scheme_name"}
                    displayKey={"scheme_name"}
                    filterKey={"scheme_name"}
                    setFilter={(val) =>
                      setValue((prev) => ({ ...prev, scheme_name: val }))
                    }
                    type={"searchable"}
                    loading={isLoading}
                  />
                </div>
              </div>
              <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
                <div className="flex w-full flex-col gap-2 ">
                  <label>Scheme Type</label>
                  <SearchableDropdown
                    data={tableData}
                    valueKey={"scheme_type"}
                    displayKey={"scheme_type"}
                    filterKey={"scheme_type"}
                    setFilter={setValue}
                    label={"Scheme Type"}
                  />
                </div>
              </div>
              <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
                <div className="flex w-full flex-col gap-2 ">
                  <label>Scheme Plan</label>
                  <SearchableDropdown
                    data={tableData}
                    valueKey={"scheme_plan"}
                    displayKey={"scheme_plan"}
                    filterKey={"scheme_plan"}
                    setFilter={setValue}
                    label={"Scheme Plan"}
                  />
                </div>
              </div>
              <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
                <div className="flex w-full flex-col gap-2 ">
                  <label className="opacity-0">.</label>
                  <div className="flex items-center border-b-[1px] border-[#636363]">
                    <img src={searchIcon} alt="" />
                    <DebouncedInput
                      value={globalFilter ?? ""}
                      onChange={(value) => setGlobalFilters(String(value))}
                      className=" bg-transparent py-1 text-neutral-800 focus:outline-none sm:w-[170px]"
                      placeholder="Search"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isFilter && (
          <MobileFilter
            filters={scripMasterFilters}
            onApply={handleApplyFilters}
            onClose={() => setIsFilter(false)}
            isFilter={isFilter}
            setSelectedValues={setSelectedValues}
            selectedValues={selectedValues}
            nofinyearDate={true}
          />
        )}
      </div>
    </>
  );
};

export default MasterMFHeader;
